import { render } from "./LogoSwitcher.vue?vue&type=template&id=4ea48fb0"
import script from "./LogoSwitcher.vue?vue&type=script&lang=js"
export * from "./LogoSwitcher.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__